


























import Vue from "vue";
import Component from "vue-class-component";
import Emit from "vue-property-decorator";
import { status } from "../../api/status/status";
import { StringHelpers } from "../../api/helpers/StringHelpers";
@Component({
  name: "ProjectDetails",
  data: function() {
    return {
      statuses: [],
      description: "",
      startdate: "",
      enddate: "",
      selectedStatus: "",
      id: ""
    };
  },
  props: {
    details: {
      default: undefined
    }
  }
})
export default class ProjectDetails extends Vue {
  public async fillboxes() {
    await this.getStatusList();
  }
  public async getStatusList() {
    await status.getAllStatuses(this.$store.getters.getToken,this.$store.getters.getHost).then(response => {
      response.json().then(resp => {
        let i = 0;
        while (i <= JSON.parse(JSON.stringify(resp)).length - 1) {
          this.$data.statuses.push({
            value: JSON.parse(JSON.stringify(resp))[i].id,
            label: StringHelpers.capitalize(
              JSON.parse(JSON.stringify(resp))[i].literal
            )
          });
          i++;
        }
      });
    });
  }
  public async mounted() {
    this.$data.row = this.$store.getters.getCurrentId;
    await this.fillboxes();
    this.CheckEdit();
    console.log(this.$data.statuses);
    this.$emit("on-loaded");
  }
  public CheckEdit() {
    if (this.$props.details != undefined) {
      this.$data.id = this.$props.details.id;
      this.$data.description = this.$props.details.description;
      this.$data.startdate = this.$props.details.start_date;
      this.$data.enddate = this.$props.details.end_date;
      this.$data.selectedStatus = this.$props.details.status_id;
    }
  }
  public destroyed() {
    let newDetails = {
      description: this.$data.description,
      end_date: this.$data.enddate,
      start_date: this.$data.startdate,
      status_id: this.$data.selectedStatus,
      id: this.$data.id
    };
    this.$emit("new-details", newDetails);
  }
}
